import "./comments/comments.scss";
//@todo convert into vue component

//Comments
const commentForm = document.getElementById("js-commentForm");
const successPanel = document.getElementById("js-commentsSuccess");
const recaptchaKey = commentForm.dataset.recaptchaKey;
const btn = commentForm.querySelector('[type="submit"]');
const btnText = btn.querySelector(".button__text");
const noticeArea = document.getElementById("js-commentNotice");

commentForm.addEventListener("submit", (e) => {
  e.preventDefault();

  //update button to show progress
  toggleButton(true);

  const data = new FormData(commentForm);

  // Set CSRF to each request, just in case
  data.set(csrfTokenName, csrfTokenValue);

  checkCaptcha(data, function (data) {
    ajax("/", {
      method: "POST",
      contentType: "formData",
      data: data,
      success: function (xhr) {
        if (xhr.notice) {
          setNotifications("notice", commentForm, xhr.notice);
        }

        if (xhr.success) {
          successPanel.classList.remove("u-hide");
          commentForm.remove();
        } else {
          setNotifications("validation", commentForm, xhr.errors);
        }
      },
      error: function (xhr) {
        setNotifications("validation", commentForm, xhr.errors);
      },
    });
  });
});

function toggleButton(working = false) {
  if (working) {
    noticeArea.innerText = "Submitting";
    btn.classList.add("button--disabled");
    btnText.innerText = "Submitting";
  } else {
    noticeArea.innerText = "";
    btn.classList.remove("button--disabled");
    btnText.innerText = "Submit";
  }
}

function checkCaptcha(formData, callback) {
  // Check for reCAPTCHA
  grecaptcha
    .execute(recaptchaKey, { action: "commentForm" })
    .then(function (token) {
      // Append value to the form and proceed
      formData.append("g-recaptcha-response", token);

      return callback(formData);
    });
}

function setNotifications(type, $element, content) {
  if (content && $element) {
    if (type === "error") {
      const errors = content.errors || content;

      Object.keys(errors).forEach(function (key) {
        $element.querySelector('[data-role="errors"]').innerHTML =
          errors[key][0];
      });
    } else if (type === "validation") {
      let msg = [];
      Object.keys(content).forEach(function (key) {
        let $field = $element.querySelector('[name="fields[' + key + ']"]');

        if (!$field) {
          $field = $element.querySelector('[name="fields[' + key + '][]"]');
        }

        if ($field) {
          $field.nextElementSibling.innerHTML = content[key][0];
          msg.push(content[key][0].replace(".", ""));
        }
      });
      noticeArea.innerHTML =
        "Unable to submit form. Please correct the following errors: " +
        msg.join(", ") +
        ".";
    } else {
      //success, do nothing
    }
  }
}

function ajax(url, settings) {
  settings = settings || {};

  const xhr = new XMLHttpRequest();
  xhr.open(settings.method || "GET", url, true);
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.setRequestHeader("Accept", "application/json");

  if (settings.contentType !== "formData") {
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  }

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      try {
        let response = JSON.parse(xhr.responseText);
        toggleButton();
        noticeArea.innerHTML = "";

        if (xhr.status === 200 && settings.success) {
          if (response.errors) {
            settings.error(response);
          } else {
            settings.success(response);
          }
        } else if (xhr.status !== 200 && settings.error) {
          if (response.error) {
            response = [[response.error]];
          }

          settings.error(response);
        }
      } catch (e) {
        settings.error([e]);
      }
    }
  };

  xhr.send(settings.data || "");
}
